module.exports = __webpack_public_path__ + "img/getstarted_submenu.5ee79ac1.gif";